import { useMemo } from 'react';
import { get } from 'lodash';
import { ChipProps } from '@mui/material';

import { RouteItemStateType } from '~globals/types/enums';

interface OrderOnAgendaStateInfoItem {
  description: string;
  color: NonNullable<ChipProps['color']>;
  tooltipMessage: string;
}

type OrderOnAgendaStateType =
  | RouteItemStateType.OnAgenda
  | RouteItemStateType.InProgress;

type OrderOnAgendaStateList = {
  [state in OrderOnAgendaStateType]: OrderOnAgendaStateInfoItem;
};

export const useOrderOnAgendaStateInfo = (
  stateId: OrderOnAgendaStateType,
): OrderOnAgendaStateInfoItem => {
  const stateList = useMemo<OrderOnAgendaStateList>(
    () => ({
      [RouteItemStateType.OnAgenda]: {
        description: 'A Despachar',
        color: 'info',
        tooltipMessage: 'Con ruta asignada, aún sin iniciar viaje.',
      },
      [RouteItemStateType.InProgress]: {
        description: 'En viaje',
        color: 'primary',
        tooltipMessage: 'En tránsito hacia destino final.',
      },
    }),
    [],
  );

  const currentInfo = useMemo<OrderOnAgendaStateInfoItem>(
    () => get(stateList, stateId),
    [stateId, stateList],
  );

  return currentInfo;
};
